<div [ngClass]="setGrayCard ? 'card-container-grey' : 'card-container-shadow'" class="padding-md" [class.card-container-active]="active">
  <div class="d-flex align-items-center">
    <div class="mr-xs">
      <app-avatar-user [image]="expert.profileImageURL" [name]="expert.name"
        [lastname]="expert.lastname" [width]="45"></app-avatar-user>
    </div>
    <div class="name">
      <p class="text-regular-14 truncate">{{ expert.name }} {{ expert.lastname
        }}</p>
      <p class="text-info truncate">{{ expert.email }}</p>
    </div>
  </div>
  <div class="card-container-icon-active" *ngIf="active">
    <img loading="lazy" src="./../../../assets/images/icons/icons8-checkmark-100.png" alt="">
  </div>
  <div class="speciality mt-xs d-flex align-items-center justify-content-between">
    <div class="text-subtitle speciality-text">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-star-100.png"
        class="mr-xxs star-icon" alt="">
      <p class="truncate" style="line-height: initial;">
        {{ expert.specializationName || 'sin especialidad'}}
      </p>
    </div>
    <p class="text-link" (click)="onEmitViewProfile()">Ver perfil</p>
  </div>
</div>
